import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { AppHeader } from '@/components/layout/app-header';
import { AppSidebar } from '@/components/layout/app-sidebar';
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar';
import { meQuery } from '@/features/auth/auth-api';

/** Signed-in area. The API enforces authentication; this only routes to login/setup. */
export const Route = createFileRoute('/_app')({
  beforeLoad: async ({ context, location }) => {
    const me = await context.queryClient.query(meQuery);
    if (me === null) {
      throw redirect({ to: '/login', search: { redirect: location.href } });
    }
    if (me.twoFactorSetupRequired) {
      throw redirect({ to: '/setup-2fa', search: { redirect: location.href } });
    }
    return { me };
  },
  component: AppLayout,
});

function AppLayout() {
  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset className="min-w-0">
        <AppHeader />
        <main className="min-w-0 flex-1 p-6">
          <Outlet />
        </main>
      </SidebarInset>
    </SidebarProvider>
  );
}
